module.exports = {
  emptyMessage: 'เฮ้! คุณลืมกรอกหมายเลขบัตรของคุณ',
  defaultMessage: 'หมายเลขบัตรที่คุณกรอกไม่ถูกต้อง ตรวจสอบให้แน่ใจว่าไม่มีการพิมพ์ผิดแล้วลองอีกครั้ง',
};
